export interface EnvironmentSettings {
  url: string;
  apiUrl: string;
  portalUrl: string;
}

export type Environment = "prod" | "prodde" | "demo" | "demode" | "staging" | "dev" | "devde" | "local" | "extacc";

export const environmentSettings: { [key in Environment]: EnvironmentSettings } = {
  local: {
    url: "https://localhost:44354",
    apiUrl: `https://localhost:60452`,
    portalUrl: `https://localhost:3000`
  },

  dev: {
    apiUrl: "https://api-dev.skolid.se",
    url: "https://dev.skolid.se",
    portalUrl: "https://admin-dev.skolid.se"
  },

  devde: {
    apiUrl: "https://api-dev.schulid.de",
    url: "https://dev.schulid.de",
    portalUrl: "https://admin-dev.schulid.de"
  },

  staging: {
    apiUrl: "https://api-staging.skolid.se",
    url: "https://staging.skolid.se",
    portalUrl: "https://admin-staging.skolid.se"
  },

  demo: {
    apiUrl: "https://api-demo.skolid.se",
    url: "https://demo.skolid.se",
    portalUrl: "https://admin-demo.skolid.se"
  },

  demode: {
    apiUrl: "https://api-demo.schulid.de",
    url: "https://demo.schulid.de",
    portalUrl: "https://admin-demo.schulid.de"
  },

  prod: {
    apiUrl: "https://api.skolid.se",
    url: "https://skolid.se",
    portalUrl: "https://admin.skolid.se"
  },

  prodde: {
    apiUrl: "https://api.schulid.de",
    url: "https://schulid.de",
    portalUrl: "http://admin.schulid.de"
  },

  extacc: {
    apiUrl: "https://api-extacc.skolid.se",
    url: "https://extacc.skolid.se",
    portalUrl: "https://admin-extacc.skolid.se"
  }
};